module.exports = (start, end, selected) => {
  let options_html = ''
  for (let i = start; i <= end; i++) {
    if (i === selected) {
      options_html += `<option value="${i}" selected>${i}</option>`
    } else {
      options_html += `<option value="${i}">${i}</option>`
    }
  }
  return new Handlebars.SafeString(options_html)
}



// WEBPACK FOOTER //
// ./webroot/js/hbs_helpers/numberSelectOptions.js